module.exports = __webpack_public_path__ + "static/img/img-individu-card.35346fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auth/img-individu-card.png
// module id = oY3W
// module chunks = 36